// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpInsistWindowPay extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.insist_window.pay";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpInsistWindowPay {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Pagar",
                "cs": "Platit",
                "da": "Betal",
                "de": "Bezahlen",
                "en": "Pay",
                "es": "Pagar",
                "eu": "Ordaindu",
                "fi": "Maksaa",
                "fr": "Payer",
                "gl": "Pagar",
                "hi": "भुगतान करें",
                "hu": "Fizetni",
                "it": "Pagare",
                "nl": "Betalen",
                "no": "Betal",
                "pt": "Pagar",
                "pt-BR": "Pagar",
                "ro": "Plăti",
                "ru": "Платить",
                "sk": "Platiť",
                "sv": "Betala",
                "tr": "Ödemek"
            },
            "defecto": "Pagar"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
